import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {AuthProvider} from "./context/AuthContext";
import {LoadingProvider} from "./context/LoadingContext";
import {SnackbarProvider} from "./context/SnackBarContext";
import AuthorizationRoute from "./route/AuthorizationRoute";
// import swDev from "./swDev";

const root = ReactDOM.createRoot(
    document.getElementById(`root`)
);

root.render(
    <React.Fragment>
        <AuthProvider>
            <LoadingProvider>
                <SnackbarProvider>
                    <BrowserRouter>
                        <AuthorizationRoute>
                            <App/>
                        </AuthorizationRoute>
                    </BrowserRouter>
                </SnackbarProvider>
            </LoadingProvider>
        </AuthProvider>
    </React.Fragment>
)


